export default "__VITE_ASSET__S8wj6e9W__"